import React, { useState, useRef, useEffect, useCallback } from 'react';
import { X, ExternalLink, ChevronRight } from 'lucide-react';

// 22 medical organizations with REAL transparent logos
// (.svg sourced from Wikipedia / official sites, .png from official sites)
const medicalOrganizations = [
  { id: 'who', abbr: 'WHO', fullName: 'World Health Organization', website: 'https://who.int', logo: '/logos/svg/who.svg', cluster: 'Глобальное здоровье', description: 'Рекомендации по физической активности и профилактике НИЗ 2024.', protocols: ['Профилактика', 'Общественное здоровье', 'Вакцинация'] },
  { id: 'esc', abbr: 'ESC', fullName: 'European Society of Cardiology', website: 'https://escardio.org', logo: '/logos/svg/esc.png', cluster: 'Кардиология', description: 'Руководства по управлению артериальной гипертензией и лечению дислипидемий (2024-2025).', protocols: ['Артериальная гипертензия', 'Дислипидемия', 'Сердечная недостаточность'] },
  { id: 'aha', abbr: 'AHA', fullName: 'American Heart Association', website: 'https://heart.org', logo: '/logos/svg/aha.svg', cluster: 'Кардиология', description: 'Протоколы профилактики сердечно-сосудистых катастроф и ведения пациентов.', protocols: ['Профилактика ССЗ', 'Инфаркт миокарда', 'Аритмии'] },
  { id: 'mayo', abbr: 'Mayo Clinic', fullName: 'Mayo Clinic Protocols', website: 'https://mayoclinic.org', logo: '/logos/svg/mayo.svg', cluster: 'Anti-Age', description: 'Интегративные подходы к активному долголетию.', protocols: ['Биомаркеры старения', 'Превентивная медицина', 'Лонгевити'] },
  { id: 'cochrane', abbr: 'Cochrane', fullName: 'Cochrane Library', website: 'https://cochranelibrary.com', logo: '/logos/svg/cochrane.svg', cluster: 'Доказательная медицина', description: 'Мета-анализы с уровнем доказательности А (наивысший).', protocols: ['Систематические обзоры', 'Мета-анализы', 'RCT'] },
  { id: 'asco', abbr: 'ASCO', fullName: 'American Society of Clinical Oncology', website: 'https://asco.org', logo: '/logos/svg/asco.png', cluster: 'Онкология', description: 'Золотой стандарт диагностики и поддерживающей терапии.', protocols: ['Онкомаркеры', 'Химиотерапия', 'Иммунотерапия'] },
  { id: 'aap', abbr: 'AAP', fullName: 'American Academy of Pediatrics', website: 'https://aap.org', logo: '/logos/svg/aap.svg', cluster: 'Педиатрия', description: 'Нормы развития, графики вакцинации и мониторинг детского здоровья.', protocols: ['Вакцинация', 'Развитие ребенка', 'Педиатрический скрининг'] },
  { id: 'kdigo', abbr: 'KDIGO', fullName: 'Kidney Disease: Improving Global Outcomes', website: 'https://kdigo.org', logo: '/logos/svg/kdigo.svg', cluster: 'Нефрология', description: 'Глобальные рекомендации по диагностике и лечению хронической болезни почек (ХБП) 2024.', protocols: ['ХБП', 'Гломерулонефрит', 'Диализ'] },
  { id: 'gold', abbr: 'GOLD', fullName: 'Global Initiative for Chronic Obstructive Lung Disease', website: 'https://goldcopd.org', logo: '/logos/svg/gold.png', cluster: 'Пульмонология', description: 'Анализ функции дыхания и рисков курильщиков.', protocols: ['ХОБЛ', 'Спирометрия', 'Бронхиальная обструкция'] },
  { id: 'eular', abbr: 'EULAR', fullName: 'European Alliance of Associations for Rheumatology', website: 'https://eular.org', logo: '/logos/svg/eular.png', cluster: 'Ревматология', description: 'Протоколы диагностики воспалительных заболеваний суставов.', protocols: ['Ревматоидный артрит', 'СКВ', 'Анкилозирующий спондилит'] },
  { id: 'esmo', abbr: 'ESMO', fullName: 'European Society for Medical Oncology', website: 'https://esmo.org', logo: '/logos/svg/esmo.png', cluster: 'Онкология', description: 'Протоколы скрининга для выявления новообразований на ранних стадиях.', protocols: ['Скрининг рака', 'Таргетная терапия', 'Паллиативная помощь'] },
  { id: 'ean', abbr: 'EAN', fullName: 'European Academy of Neurology', website: 'https://ean.org', logo: '/logos/svg/ean.png', cluster: 'Неврология', description: 'Протоколы диагностики цереброваскулярных заболеваний и профилактики деменции.', protocols: ['Инсульт', 'Деменция', 'Микроангиопатия'] },
  { id: 'easl', abbr: 'EASL', fullName: 'European Association for the Study of the Liver', website: 'https://easl.eu', logo: '/logos/svg/easl.png', cluster: 'Гастроэнтерология', description: 'Рекомендации по лечению неалкогольной жировой болезни печени.', protocols: ['НАЖБП', 'Гепатит', 'Цирроз'] },
  { id: 'apa', abbr: 'APA', fullName: 'American Psychiatric Association', website: 'https://psychiatry.org', logo: '/logos/svg/apa.svg', cluster: 'Психиатрия', description: 'Оценка маркеров стресса, депрессии и тревожных расстройств (DSM-5).', protocols: ['Депрессия', 'Тревожность', 'ПТСР'] },
  { id: 'acog', abbr: 'ACOG', fullName: 'American College of Obstetricians and Gynecologists', website: 'https://acog.org', logo: '/logos/svg/acog.svg', cluster: 'Гинекология', description: 'Стандарты женского здоровья и гормональной коррекции.', protocols: ['ЗГТ', 'Менопауза', 'Пренатальный скрининг'] },
  { id: 'nccn', abbr: 'NCCN', fullName: 'National Comprehensive Cancer Network', website: 'https://nccn.org', logo: '/logos/svg/nccn.png', cluster: 'Онкология', description: 'Клинические рекомендации по онкологической настороженности.', protocols: ['BRCA', 'ПЭТ-КТ', 'Биопсия'] },
  { id: 'gina', abbr: 'GINA', fullName: 'Global Initiative for Asthma', website: 'https://ginasthma.org', logo: '/logos/svg/gina.png', cluster: 'Пульмонология', description: 'Стандарты ведения пациентов с астмой.', protocols: ['Бронхиальная астма', 'Пиковая скорость выдоха', 'Ингаляторы'] },
  { id: 'acg', abbr: 'ACG', fullName: 'American College of Gastroenterology', website: 'https://gi.org', logo: '/logos/svg/acg.svg', cluster: 'Гастроэнтерология', description: 'Стандарты скрининга заболеваний ЖКТ и коррекции микробиома.', protocols: ['Гастрит', 'ГЭРБ', 'Колоноскопия'] },
  { id: 'eau', abbr: 'EAU', fullName: 'European Association of Urology', website: 'https://uroweb.org', logo: '/logos/svg/eau.png', cluster: 'Урология', description: 'Протоколы здоровья простаты и мужского гормонального статуса.', protocols: ['ПСА', 'Тестостерон', 'ДГПЖ'] },
  { id: 'ada', abbr: 'ADA', fullName: 'American Diabetes Association', website: 'https://diabetes.org', logo: '/logos/svg/ada.svg', cluster: 'Эндокринология', description: 'Стандарты медицинской помощи при сахарном диабете и предиабете 2025.', protocols: ['Сахарный диабет', 'Предиабет', 'HbA1c'] },
  { id: 'easd', abbr: 'EASD', fullName: 'European Association for the Study of Diabetes', website: 'https://easd.org', logo: '/logos/svg/easd.svg', cluster: 'Эндокринология', description: 'Современные алгоритмы управления инсулинорезистентностью.', protocols: ['Инсулинорезистентность', 'Метформин', 'GLP-1'] },
  { id: 'aan', abbr: 'AAN', fullName: 'American Academy of Neurology', website: 'https://aan.com', logo: '/logos/svg/aan.svg', cluster: 'Неврология', description: 'Стандарты терапии нарушений сна и мигреней.', protocols: ['Мигрень', 'Эпилепсия', 'Рассеянный склероз'] }
];

/* Per-logo display scale.
   Default = 2.0 (text-heavy logos boosted to match presence of square ones).
   Square logos that already fill their slot stay at 1.0.
   User-requested fine-tuning: eular & gold shrunk 1.5×; gina kept at full 2×. */
const DEFAULT_BOOST = 2.0;
const LOGO_SCALE = {
  acg: 1.0,
  mayo: 1.0,
  kdigo: 1.0,
  esmo: 1.0,
  // ↓ user feedback: these two are too big — shrink 1.5× ↓
  eular: 2.0 / 1.5, // ≈ 1.33
  gold: 2.0 / 1.5,  // ≈ 1.33
  // gina uses default 2.0 (full boost)
};

/* ────────────────────────────────────────────────────────────────
   Glass Modal — expands from the clicked logo with scale-from-void
──────────────────────────────────────────────────────────────── */
const OrganizationModal = ({ organization, isOpen, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const id = requestAnimationFrame(() => setVisible(true));
      return () => cancelAnimationFrame(id);
    }
    setVisible(false);
  }, [isOpen]);

  if (!isOpen || !organization) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      style={{
        background: visible ? 'rgba(5, 6, 11, 0.55)' : 'rgba(5, 6, 11, 0)',
        transition: 'background 0.35s ease-out',
      }}
      onClick={onClose}
      data-testid="org-modal-overlay"
    >
      <div
        className="relative w-full max-w-lg origin-center will-change-transform"
        onClick={(e) => e.stopPropagation()}
        data-testid="org-modal-content"
        style={{
          transform: visible ? 'scale(1) translateY(0)' : 'scale(0.2) translateY(20px)',
          opacity: visible ? 1 : 0,
          filter: visible ? 'blur(0px)' : 'blur(14px)',
          transition:
            'transform 0.55s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.45s ease-out, filter 0.45s ease-out',
        }}
      >
        <div
          className="relative rounded-[28px] p-6 md:p-8 overflow-hidden"
          style={{
            background:
              'linear-gradient(145deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.02) 50%, rgba(255,255,255,0.01) 100%), rgba(22,24,34,0.92)',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow:
              'inset 0 1px 0 0 rgba(255,255,255,0.14), inset 0 -1px 0 0 rgba(0,0,0,0.3), 0 30px 80px -15px rgba(0,0,0,0.65), 0 6px 20px rgba(0,0,0,0.35)',
          }}
        >
          <div
            aria-hidden
            className="absolute top-0 left-[15%] right-[15%] h-px pointer-events-none"
            style={{
              background:
                'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
            }}
          />

          <div className="flex items-start justify-between mb-6 relative">
            <div className="flex items-center gap-4">
              <div
                className="w-20 h-20 rounded-2xl flex items-center justify-center p-2 overflow-hidden shrink-0"
              >
                <img
                  src={organization.logo}
                  alt={organization.fullName}
                  className="w-full h-full object-contain"
                  style={{
                    filter:
                      'drop-shadow(0 0 6px rgba(255,255,255,0.5)) drop-shadow(0 0 16px rgba(255,255,255,0.18))',
                  }}
                  loading="lazy"
                />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-white">{organization.abbr}</h3>
                <p className="text-sm text-white/60 max-w-[220px] leading-snug">
                  {organization.fullName}
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-full text-white/80 hover:text-white transition-all"
              style={{
                background:
                  'linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.03) 100%), rgba(40,42,54,0.6)',
                border: '1px solid rgba(255,255,255,0.12)',
                boxShadow:
                  'inset 0 1px 0 0 rgba(255,255,255,0.18), 0 3px 8px rgba(0,0,0,0.28)',
              }}
              data-testid="org-modal-close"
              aria-label="Закрыть"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full mb-4 relative"
            style={{
              background: 'rgba(10, 132, 255, 0.12)',
              border: '1px solid rgba(10, 132, 255, 0.3)',
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.15)',
            }}
          >
            <span className="text-sm text-cyan-300 font-medium">{organization.cluster}</span>
          </div>

          <p className="text-white/80 leading-relaxed mb-6 relative">
            {organization.description}
          </p>

          <div className="mb-6 relative">
            <h4 className="text-xs uppercase tracking-wider font-medium text-white/50 mb-3">
              Ключевые протоколы
            </h4>
            <div className="flex flex-wrap gap-2">
              {organization.protocols.map((protocol, idx) => (
                <span
                  key={idx}
                  className="px-3 py-1.5 rounded-full text-sm text-white/85"
                  style={{
                    background:
                      'linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.02) 100%), rgba(40,42,54,0.5)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.12)',
                  }}
                >
                  {protocol}
                </span>
              ))}
            </div>
          </div>

          <a
            href={organization.website}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center justify-center gap-2 w-full py-3 rounded-full text-white font-medium transition-all relative"
            style={{
              background:
                'linear-gradient(180deg, rgba(10,132,255,0.4) 0%, rgba(10,132,255,0.18) 100%)',
              border: '1px solid rgba(10,132,255,0.5)',
              boxShadow:
                'inset 0 1px 0 rgba(255,255,255,0.25), 0 6px 18px rgba(10,132,255,0.3)',
            }}
            data-testid="org-modal-link"
          >
            <ExternalLink className="w-4 h-4" />
            <span>Официальный сайт</span>
            <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </div>
  );
};

/* ────────────────────────────────────────────────────────────────
   3D Cylindrical Carousel
   • Real CSS 3D: perspective + rotateY + translateZ
   • Logos sit on a cylinder, the cylinder spins around the Y axis
   • Each logo counter-rotates so the artwork stays readable
   • Back-facing items fade out automatically
   • Logos render on a soft white "glass chip" so transparent PNGs
     look crisp regardless of the dark background.
──────────────────────────────────────────────────────────────── */
const CylinderCarousel = ({ items, onItemClick }) => {
  const [rotation, setRotation] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [autoPlay, setAutoPlay] = useState(true);
  const [viewport, setViewport] = useState({ w: 1440 });
  const dragRef = useRef({ startX: 0, startRot: 0, lastX: 0, lastT: 0, vel: 0 });
  const rafRef = useRef(null);

  // Responsive viewport tracking
  useEffect(() => {
    const onResize = () => setViewport({ w: window.innerWidth });
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Auto-rotate (10° / sec)
  useEffect(() => {
    if (!autoPlay || isDragging) return;
    let last = performance.now();
    const tick = (now) => {
      const dt = now - last;
      last = now;
      setRotation((r) => r + (dt / 1000) * 10);
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [autoPlay, isDragging]);

  // Momentum after drag end
  const startMomentum = useCallback(() => {
    const decay = () => {
      const v = dragRef.current.vel;
      if (Math.abs(v) < 0.05) {
        setAutoPlay(true);
        return;
      }
      setRotation((r) => r + v);
      dragRef.current.vel = v * 0.94;
      rafRef.current = requestAnimationFrame(decay);
    };
    rafRef.current = requestAnimationFrame(decay);
  }, []);

  const beginDrag = (clientX) => {
    cancelAnimationFrame(rafRef.current);
    setIsDragging(true);
    setAutoPlay(false);
    dragRef.current = {
      startX: clientX,
      startRot: rotation,
      lastX: clientX,
      lastT: performance.now(),
      vel: 0,
    };
  };

  const moveDrag = useCallback(
    (clientX) => {
      if (!isDragging) return;
      const sensitivity = viewport.w < 768 ? 0.35 : 0.22;
      const delta = clientX - dragRef.current.startX;
      const newRot = dragRef.current.startRot + delta * sensitivity;
      setRotation(newRot);

      const now = performance.now();
      const dt = Math.max(now - dragRef.current.lastT, 1);
      dragRef.current.vel = ((clientX - dragRef.current.lastX) * sensitivity) * (16 / dt);
      dragRef.current.lastX = clientX;
      dragRef.current.lastT = now;
    },
    [isDragging, viewport.w]
  );

  const endDrag = useCallback(() => {
    if (!isDragging) return;
    setIsDragging(false);
    startMomentum();
  }, [isDragging, startMomentum]);

  // Global pointer listeners while dragging
  useEffect(() => {
    if (!isDragging) return;
    const onMove = (e) => {
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      moveDrag(x);
    };
    const onUp = () => endDrag();
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onUp);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
    };
  }, [isDragging, moveDrag, endDrag]);

  // Layout: cylinder geometry
  const total = items.length;
  const angleStep = 360 / total;
  const isMobile = viewport.w < 640;
  const isTablet = viewport.w >= 640 && viewport.w < 1024;
  // Bigger logos now that the white chip background is gone
  const itemSize = isMobile ? 150 : isTablet ? 190 : 230;
  // Radius +20 % — receding 3-D effect is now visibly stronger:
  // back-side logos sit further away & shrink more aggressively.
  // (was 2.0 multiplier, now 2.4)
  const radius = Math.round((itemSize * 2.4) / (2 * Math.sin(Math.PI / total)));
  // Stage height grows to fit the 2×-scaled wide logos without clipping
  const stageH = Math.round(itemSize * 1.8);

  return (
    <div
      className="relative w-full select-none"
      style={{
        height: stageH,
        perspective: '1600px',
        perspectiveOrigin: '50% 50%',
        cursor: isDragging ? 'grabbing' : 'grab',
        touchAction: 'pan-y',
      }}
      onMouseDown={(e) => beginDrag(e.clientX)}
      onTouchStart={(e) => beginDrag(e.touches[0].clientX)}
      onMouseEnter={() => setAutoPlay(false)}
      onMouseLeave={() => !isDragging && setAutoPlay(true)}
      data-testid="drum-carousel"
    >
      {/* Spinning cylinder */}
      <div
        className="absolute left-1/2 top-1/2"
        style={{
          width: itemSize,
          height: itemSize,
          marginLeft: -itemSize / 2,
          marginTop: -itemSize / 2,
          transformStyle: 'preserve-3d',
          transform: `translateZ(${-radius}px) rotateY(${rotation}deg)`,
          willChange: 'transform',
        }}
      >
        {items.map((item, i) => {
          const a = i * angleStep;
          // Normalise angle relative to the front (camera) direction
          const facing = ((a + rotation) % 360 + 360) % 360;
          const fromFront = facing > 180 ? 360 - facing : facing;
          // Fade items as they rotate to the back
          const opacity =
            fromFront < 50 ? 1 : fromFront < 90 ? 1 - (fromFront - 50) / 60 : 0.15;
          const isFront = fromFront < 90;
          // Per-logo size boost via LOGO_SCALE map (default = 2×)
          const boost = LOGO_SCALE[item.id] ?? DEFAULT_BOOST;

          return (
            <button
              key={item.id}
              type="button"
              onClick={(e) => {
                if (Math.abs(dragRef.current.vel) > 0.5) return;
                e.stopPropagation();
                onItemClick(item);
              }}
              className="absolute inset-0 group focus:outline-none"
              style={{
                transform: `rotateY(${a}deg) translateZ(${radius}px)`,
                opacity,
                pointerEvents: isFront ? 'auto' : 'none',
                transition: isDragging ? 'none' : 'opacity 0.35s ease-out',
                backfaceVisibility: 'hidden',
              }}
              data-testid={`org-logo-${item.id}`}
              aria-label={item.fullName}
            >
              {/* Pure logo on transparent background — readable thanks to a soft white halo */}
              <div
                className="w-full h-full flex items-center justify-center transition-transform duration-300 group-hover:scale-[1.08]"
                style={{
                  // Per-item boost — wide text logos go 2×, square ones stay 1×
                  transform: `scale(${boost})`,
                }}
              >
                <img
                  src={item.logo}
                  alt={item.fullName}
                  className="max-w-full max-h-full object-contain"
                  style={{
                    // Dual-layer halo: tight white outline for legibility +
                    // wider soft glow for ambient lift. Tracks the logo silhouette
                    // so every dark/coloured logo stays readable on the cosmic bg.
                    filter:
                      'drop-shadow(0 0 1px rgba(255,255,255,1)) drop-shadow(0 0 4px rgba(255,255,255,0.7)) drop-shadow(0 0 16px rgba(255,255,255,0.35)) drop-shadow(0 6px 14px rgba(0,0,0,0.5))',
                  }}
                  draggable={false}
                  loading="lazy"
                />
              </div>
            </button>
          );
        })}
      </div>

      {/* Side dark fade removed per user request — must look like logos float in open space */}

      <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 text-white/35 text-[11px] z-30 pointer-events-none">
        <span className="hidden md:inline">Потяните, чтобы вращать</span>
        <span className="md:hidden">Свайпните для вращения</span>
      </div>
    </div>
  );
};

/* ────────────────────────────────────────────────────────────────
   Section wrapper
──────────────────────────────────────────────────────────────── */
const MedicalProtocolsSection = () => {
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOrgClick = (org) => {
    setSelectedOrg(org);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <section className="relative py-12 md:py-20" data-testid="medical-protocols-section">
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center px-4 mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 mb-6">
            <span className="text-sm text-white/70">14 кластеров медицинских знаний</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-white leading-tight mb-4">
            Глобальная научная база
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              AiMedGuru
            </span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-white/60 max-w-3xl mx-auto leading-relaxed">
            Каждый отчет верифицируется через призму доказательной медицины уровней А и В на
            основе международных протоколов
          </p>
        </div>

        <div className="relative py-4 px-0">
          <CylinderCarousel items={medicalOrganizations} onItemClick={handleOrgClick} />
        </div>

        <div className="px-4 mt-10 flex justify-center">
          <div
            className="liquid-glass-card relative rounded-[24px] px-6 py-5 md:px-8 md:py-6 max-w-3xl w-full"
            data-testid="algorithms-update-note"
          >
            <p className="relative z-10 text-sm md:text-base text-white/75 text-center leading-relaxed">
              Алгоритмы AiMedGuru обновляются ежемесячно, интегрируя свежие данные клинических
              испытаний, опубликованных в{' '}
              <span className="text-cyan-300 font-medium">The Lancet</span>,{' '}
              <span className="text-cyan-300 font-medium">NEJM</span> и{' '}
              <span className="text-cyan-300 font-medium">JAMA</span>
            </p>
          </div>
        </div>
      </div>

      <OrganizationModal
        organization={selectedOrg}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </section>
  );
};

export default MedicalProtocolsSection;
